import React from 'react';

const Button = ({ label, classes, click = () => {}, disabled, icon }) => {
    return (
        <button disabled={ disabled } className={ classes } onClick={click}>
            { icon && <span className="button-icon"><i className={`${icon}`}></i></span>} { label }
        </button>
    );
}

export default Button;